/**
 * Handing the browser a file to save, from text already fetched: an export
 * is a POST that the worker logs, so it cannot be a link the browser follows.
 */
export function save(filename: string, text: string, type: string): void {
  const url = URL.createObjectURL(new Blob([text], { type: `${type};charset=utf-8` }));
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
